export const decimals = (value: number, decimalPlaces = 2, truncateWholeNumbers = true): string => {
    if (truncateWholeNumbers && value % 1 === 0) {
        return value.toFixed(0);
    }
    return value.toFixed(decimalPlaces);
};
